import { memo, useCallback } from 'react';

import { XIcon } from '@air/design-icons';
import { Button } from '@air/primitive-button';

import { SearchFieldClearButton } from '~/components/Search/SearchFieldClearButton';
import { useSearchParams } from '~/hooks/search/useSearchParams';
import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';

export type PublicShowcaseSearchActionsProps = {
  onClearSearchValue: () => void;
};

export const PublicShowcaseSearchActions = memo(({ onClearSearchValue }: PublicShowcaseSearchActionsProps) => {
  const { search, clearSearch } = useSearchParams();
  const { ui2026 } = useTemporaryFeatureFlags();

  const handleClick = useCallback(() => {
    clearSearch();
    onClearSearchValue();
  }, [onClearSearchValue, clearSearch]);

  if (!search) {
    return null;
  }

  if (ui2026) {
    return <SearchFieldClearButton data-testid="CLEAR_FILTER_BUTTON" label="Clear" onClick={handleClick} />;
  }

  return (
    <Button
      appearance="outline"
      color="gray"
      data-testid="CLEAR_FILTER_BUTTON"
      onClick={handleClick}
      prefix={<XIcon size="xs" />}
      size="small"
    >
      Clear
    </Button>
  );
});

PublicShowcaseSearchActions.displayName = 'PublicShowcaseSearchActions';
